import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import axios from "axios";
import CountUp from "react-countup";
import Widget from "../../../../../components/Widget/Widget";

const PageViews = () => {
  const [pageViewsData, setPageViewsData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async (firstLoad) => {
    if(firstLoad){
      setLoading(true);
    }
    try {
      const response = await axios.get(
        "https://eadash.arabiansystems.com/api/Dashboard/FacebookAnalytics/PageViews"
      );
      const data = response.data;
      setPageViewsData(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(true);
    const interval = setInterval(() => {
      fetchData(false);
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Widget fetchingData={loading}>
      <div className="clearfix height140 relativeDiv">
        <Row className="flex-nowrap">
          <Col xs={3}>
            <img
              src="/icons/views.png"
              width={window.innerWidth < 1576 ? "40" : "60"}
            />
          </Col>
          <Col xs={9}>
            <h6 className="m-0">Total Page Views</h6>
            <p className="h2 m-0 fw-normal">
              <CountUp
                start={0}
                end={pageViewsData?.totalViews}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
        </Row>
        {/* <Row className="flex-nowrap marginTop36">
          <Col xs="6">
            <h6 className="m-0">Current Month</h6>
            <p className="value5">
              <CountUp
                start={0}
                end={pageViewsData?.currentMonthViews}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
          <Col xs={6}>
            <h6 className="m-0">Previous Month</h6>
            <p className="value5">
              <CountUp
                start={0}
                end={pageViewsData?.previousMonthViews}
                duration={2}
                separator=","
                enableScrollSpy
              />
            </p>
          </Col>
        </Row> */}
        <Row>
          <Col xs={12}>
            <div className="marginTop10 infoFlex absoDiv">
              <i class="fa fa-info-circle"></i>
              <p className="m-0">Based on data from the last 30 days</p>
            </div>
          </Col>
        </Row>
      </div>
    </Widget>
  );
};

export default PageViews;
